
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {TickClient} from '../core/TickClient';
import {FieldModelTickClient} from '../core/TickClient';

/**
 * TickSnapshotNotify struct
 */
class TickSnapshotNotify {
  /**
   * Initialize struct
   * @param {!Map=} ticks
   * @constructor
   */
  constructor (ticks = new Map()) {
    this.Ticks = ticks
  }

  /**
   * Copy struct (shallow copy)
   * @this {!TickSnapshotNotify}
   * @param {!TickSnapshotNotify} other Other struct
   * @returns {!TickSnapshotNotify} This struct
   */
  copy (other) {
    if (other.Ticks != null) {
      this.Ticks = new Map()
      Object.keys(other.Ticks).forEach(key => {
        if (key != null) {
          let tempKey
          tempKey = key
          if (other.Ticks[key] != null) {
            let tempValue
            tempValue = TickClient.fromObject(other.Ticks[key])
            this.Ticks.set(tempKey, tempValue)
          } else {
            this.Ticks.set(tempKey, null)
          }
        }
      })
    } else {
      this.Ticks = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!TickSnapshotNotify}
   * @returns {!TickSnapshotNotify} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new TickSnapshotNotifyModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new TickSnapshotNotifyModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!TickSnapshotNotify}
   * @param {!TickSnapshotNotify} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TickSnapshotNotify)) {
      throw new TypeError('Instance of TickSnapshotNotify is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!TickSnapshotNotify}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      Ticks: ((this.Ticks != null) ? fbe.MapToObject(new Map(Array.from(this.Ticks, item => [((item[0] != null) ? item[0] : null), ((item[1] != null) ? item[1] : null)]))) : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return TickSnapshotNotify.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!TickSnapshotNotify} other Object value
   * @returns {!TickSnapshotNotify} Created struct
   */
  static fromObject (other) {
    return new TickSnapshotNotify().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!TickSnapshotNotify}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return TickSnapshotNotify.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!TickSnapshotNotify}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5051
  }
}

export { TickSnapshotNotify };

/**
 * Fast Binary Encoding TickSnapshotNotify field model
 */
class FieldModelTickSnapshotNotify extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.Ticks = new fbe.FieldModelMap(new fbe.FieldModelString(buffer, 4 + 4), new FieldModelTickClient(buffer, 4 + 4), buffer, 4 + 4)
  }

  /**
   * Get the field size
   * @this {!FieldModelTickSnapshotNotify}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelTickSnapshotNotify}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.Ticks.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelTickSnapshotNotify}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.Ticks.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelTickSnapshotNotify}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelTickSnapshotNotify.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelTickSnapshotNotify}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5051
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelTickSnapshotNotify}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelTickSnapshotNotify}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Ticks.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Ticks.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Ticks.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelTickSnapshotNotify}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelTickSnapshotNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelTickSnapshotNotify}
   * @param {!TickSnapshotNotify} fbeValue Default value, defaults is new TickSnapshotNotify()
   * @returns {!TickSnapshotNotify} TickSnapshotNotify value
   */
  get (fbeValue = new TickSnapshotNotify()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelTickSnapshotNotify}
   * @param {!TickSnapshotNotify} fbeValue TickSnapshotNotify value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Ticks.fbeSize) <= fbeStructSize) {
      this.Ticks.get(fbeValue.Ticks)
    } else {
      fbeValue.Ticks.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Ticks.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelTickSnapshotNotify}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelTickSnapshotNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelTickSnapshotNotify}
   * @param {!TickSnapshotNotify} fbeValue TickSnapshotNotify value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelTickSnapshotNotify}
   * @param {TickSnapshotNotify} fbeValue TickSnapshotNotify value
   */
  setFields (fbeValue) {
    this.Ticks.set(fbeValue.Ticks)
  }
}

export { FieldModelTickSnapshotNotify };

/**
 * Fast Binary Encoding TickSnapshotNotify model
 */
class TickSnapshotNotifyModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelTickSnapshotNotify(this.buffer, 4)
  }

  /**
   * Get the TickSnapshotNotify model
   * @this {!TickSnapshotNotifyModel}
   * @returns {!FieldModelTickSnapshotNotify} model TickSnapshotNotify model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!TickSnapshotNotifyModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!TickSnapshotNotifyModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return TickSnapshotNotifyModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!TickSnapshotNotifyModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelTickSnapshotNotify.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!TickSnapshotNotifyModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!TickSnapshotNotifyModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!TickSnapshotNotifyModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!TickSnapshotNotifyModel}
   * @param {!TickSnapshotNotify} value TickSnapshotNotify value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!TickSnapshotNotifyModel}
   * @param {!TickSnapshotNotify} value TickSnapshotNotify value, defaults is new TickSnapshotNotify()
   * @return {!object} Deserialized TickSnapshotNotify value and its size
   */
  deserialize (value = new TickSnapshotNotify()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new TickSnapshotNotify(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new TickSnapshotNotify(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!TickSnapshotNotifyModel}
   * @param {!number} prev Previous TickSnapshotNotify model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { TickSnapshotNotifyModel };
